module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAgMAAABinRfyAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURf///0dwTP///////52frr0AAAADdFJOU2AA8XgbzXQAAAA7SURBVAjXNYxBDQAgDANrAiHzsRfjJCFtvoAmfJo0vZ42TAWkEkI1Vmt1DRGJyLhR/cP1DUYM+2bBUx1mjhXDMlbXzwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.png
// module id = zsRw
// module chunks = 34